import React, { useState, useEffect } from "react";

import db from "../../services/query";

import PrintHeader from "./common/PrintHeader";
import PrintBodyTitle from "./common/PrintBodyTitle";
import PrintTable from "./common/PrintTable";

const FacultiesPastBalance = () => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  let title =  "مصارف پوهنحی ها";

  const columns = [
      { path: "id", label: "شماره" },
      { path: "faculty", label: "پوهنحی"},
      { path: "opening_balance", label: "حساب قبلی" },
      { path: "paid", label: "پرداخت شده" },
      { path: "balance", label: "باقیمانده" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `expenses/salary/faculties/balances`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        title={title}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default FacultiesPastBalance;
